import '../../common_screen/my_contest_tab/index_web.css';
import I18n from '../../../utilities/locale';
import { ContestCard, ContestShare, NoContestJoined } from '../../component';
import React from 'react';

const MyContestListWeb = ({
  challenges,
  onPressCard,
  onPressShare,
  matchItem,
  totalTeamsCount,
  gameState,
  gameType,
  matchStatus,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  onPressJoinContest,
  matchDelayed
}: any) => {
  return (
    <>
      {challenges.length > 0 ? (
        <div className="my_contest_list_card_wrapper">
          {challenges.map((item: any) => (
            <ContestCard
              key={item._id}
              contest={item}
              onPressCard={() => onPressCard(item, false)}
              matchStatus={matchStatus}
              onPressShare={() => onPressShare()}
              matchItem={matchItem}
              totalTeamsCount={totalTeamsCount}
              screenName={'MY_JOINED_CONTEST'}
              matchDelayed={matchDelayed}
              gameState={gameState}
              gameType={gameType}
            />
          ))}
        </div>
      ) : (
        <NoContestJoined
          message={I18n.t('NoContestJoined')}
          buttonLabel={I18n.t('JoinYourContest')}
          onPress={onPressJoinContest}
        />
      )}
      <ContestShare
        link={contestLink}
        contestTitle={contestTitle}
        visible={contestShare}
        onPressDismiss={onPressShareModalDismiss}
      />
    </>
  );
};

export default React.memo(MyContestListWeb);
